import { render, staticRenderFns } from "./GLazyComponent.vue?vue&type=template&id=7d2a9e72&"
import script from "./GLazyComponent.vue?vue&type=script&lang=js&"
export * from "./GLazyComponent.vue?vue&type=script&lang=js&"
import style0 from "./GLazyComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports